import React from "react";
import Card from "../../components/Card/Card";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import TitleBanner from "../../components/TitleBanner/TitleBanner";

function History({ deliveredProducts, updateList, setUpdateList }) {
  return (
    <div>
      <TitleBanner
        color="blue"
        title="Histórico"
        subtitle="Tickets utilizados nas Aldeias Históricas de Portugal."
      />

      <CardGridWrapper>
        {deliveredProducts.length > 0 &&
          deliveredProducts?.map((product, index) => (
            // <ReservationCard store={r} key={index}></ReservationCard>
            <Card
              entity={product.type}
              product={product}
              key={index}
              updateList={updateList}
              reserveBtn={false}
              setUpdateList={setUpdateList}
              context="ticket"
            ></Card>
          ))}
      </CardGridWrapper>
    </div>
  );
}

export default History;
